/*
 * Helper to get distinct color depoending the given string
 *
 * NOTE: after @babel is upgraded and we have "@babel/plugin-proposal-class-properties" then
 * use static class properties...
 */
class ColorHelpers {

  // Google material colors which are dark enough to use white text
  colors() {
    return [ '#EF5350', '#F44336', '#E53935', '#D32F2F', '#C62828', '#B71C1C', '#EC407A', '#E91E63', '#D81B60',
             '#C2185B', '#AD1457', '#880E4F', '#AB47BC', '#9C27B0', '#8E24AA', '#7B1FA2', '#6A1B9A', '#4A148C',
             '#7E57C2', '#673AB7', '#5E35B1', '#512DA8', '#4527A0', '#311B92', '#5C6BC0', '#3F51B5', '#3949AB',
             '#303F9F', '#283593', '#1A237E', '#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1', '#0097A7',
             '#00838F', '#006064', '#009688', '#00897B', '#00796B', '#00695C', '#004D40', '#43A047', '#388E3C',
             '#2E7D32', '#1B5E20', '#689F38', '#558B2F', '#33691E', '#827717', '#EF6C00', '#E65100', '#FF5722',
             '#F4511E', '#E64A19', '#D84315', '#BF360C', '#8D6E63', '#795548', '#6D4C41', '#5D4037', '#4E342E',
             '#3E2723' ]
  }

  /*
   * Get one color from palette based on text signature.
   */
  getColor(string) {
    const colors = this.colors()
    
    // lets convert string to UTF-8 to mimic the logic in PHP and to get same value and color as in there
    const text = this.toUTF8(string)

    let value = 0

    for(let i = 0; i < text.length; i++) {
      value += text.charCodeAt(i)
    }
    
    const index = value % colors.length;
    
    return colors[index];
  }

  toUTF8(string) {
    // unescape is decprecated but maybe it will be supported by the browsers. See comments here:
    // http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
    return unescape(encodeURIComponent(string))
  }
}

export {
  ColorHelpers
}
